import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonTile } from './Tile.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTile({ prefix }));
}
